import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image'

type Props = {
  src: string
  alt?: string
  heroImages: { nodes: HeroImage[] }
  index: number
}

type HeroImage = {
  childImageSharp: {
    gatsbyImageData: IGatsbyImageData
  }
  publicURL: string
}

interface GatsbyImageProp {
  publicURL: string
  image: IGatsbyImageData
}

export const HeroImageWrapper = (props: Props) => {
  let gatsbyImageData: GatsbyImageProp = {
    publicURL: '',
    image: {
      layout: 'fixed',
      width: 0,
      height: 0,
      images: {
        sources: [],
        fallback: { src: '' },
      },
    },
  }

  const regex = /(___)([^\.]+)\.(png|tiff|jpg|gif|jpeg)/
  const matchResult = props.src?.match(regex)

  if (matchResult && matchResult[2]) {
    let result = props.heroImages.nodes.find((el: HeroImage) =>
      el.publicURL.includes(matchResult[2])
    )

    if (result) {
      gatsbyImageData = {
        publicURL: result.publicURL,
        image: result.childImageSharp.gatsbyImageData,
      }
    }
  }

  const image = getImage(gatsbyImageData?.image)

  return (
    image && (
      <GatsbyImage
        className="w-auto h-auto rounded-t-md"
        objectFit="contain"
        image={image}
        alt={props.alt ?? 'hero carousel image'}
        loading={props.index <= 2 ? 'eager' : 'lazy'}
      />
    )
  )
}
